import VaccinesIcon from '@mui/icons-material/TrackChanges';
import { TargetList } from './Target.List';
import { TargetCreate } from './Target.Create';
import { TargetEdit } from './Target.Edit';
import { TargetUpload } from './Target.Upload';

export default {
    list: TargetList,
    create: TargetCreate,
    edit: TargetEdit,
    upload: TargetUpload,
    icon: VaccinesIcon,
};
